import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { LOCATION, PHONE } from "../../../assets/icons";
import {
  CustomButton,
  FormModalTitle,
  SvgContainer,
} from "../../../components";
import SigninTextInput from "../../../components/SigninTextInput";
import i18n from "../../../i18n-config";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 400, md: 550, lg: 550 },
  backgroundColor: "#ffffff",
  borderRadius: 2,
  padding: 3,
};

interface Props {
  open: boolean;
  onClose(): void;
}

function CorbeilleForm({ open, onClose }: Props) {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    localisation: "",
  });

  const onChangeField = (key: string, value: string) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <form>
        <Box sx={style}>
          <FormModalTitle
            title={i18n.t("ajouter_un_boss")}
            onClose={handleClose}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("nom"))}
            value={formData.name}
            onChange={(value: string) => onChangeField("name", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("prenom"))}
            value={formData.surname}
            onChange={(value: string) => onChangeField("surname", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("email"))}
            value={formData.email}
            onChange={(value: string) => onChangeField("email", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("telephone"))}
            value={formData.phone}
            icon={
              <Box mt={0.5}>
                <SvgContainer
                  svg={PHONE}
                  width={15}
                  color={theme.colors.dimgray + "80"}
                />
              </Box>
            }
            onChange={(value: string) => onChangeField("phone", value)}
          />
          <SigninTextInput
            title={capitalizeFirstLetter(i18n.t("localisation"))}
            value={formData.localisation}
            icon={
                <Box>
                  <SvgContainer
                    svg={LOCATION}
                    width={15}
                    color={theme.colors.dimgray + "80"}
                  />
                </Box>
              }
            onChange={(value: string) => onChangeField("localisation", value)}
          />
          <CustomButton
            title={capitalizeFirstLetter(i18n.t("ajouter_boss"))}
            //   onClick={onSubmit}
            //   disabled={disabled}
            rootStyle={{
              width: "100%",
              height: 50,
              marginTop: 3,
              marginBottom: 2,
            }}
            titleStyle={{ color: theme.colors.white }}
          />
        </Box>
      </form>
    </Modal>
  );
}

export default CorbeilleForm;
